<template>
  <v-dialog max-width="650" v-model="dialog.shows.showProvision">
    <v-card>
      <v-card-title>
        <div class="title">{{ $vuetify.lang.t(dialog.title) }}</div>
      </v-card-title>
      <v-divider></v-divider>
      <v-form @submit.prevent="sendForm">
        <v-card-text>
          <v-container>
            <v-row wrap>
              <v-col class="mb-0 py-0" cols="12" sm="6">
                <v-text-field
                  :error="!_.isNull(apiFormErrors['amount'])"
                  :error-messages="!_.isEmpty(errorsAmount)?errorsAmount:apiFormErrors['amount']"
                  :label="$vuetify.lang.t('$vuetify.provision.cols.amount.title2')"
                  @blur="$v.form.amount.$touch()"
                  @input="$v.form.amount.$touch()"
                  prepend-icon="mdi-cash"
                  autocomplete="off"
                  v-model="form.amount"
                ></v-text-field>
              </v-col>
              <v-col class="mb-0 py-0" cols="12" sm="6">
                <v-select
                  :error="!_.isNull(apiFormErrors['operation'])"
                  :error-messages="!_.isEmpty(errorsOperation)?errorsOperation:apiFormErrors['operation']"
                  :items="itemsOperations"
                  :label="$vuetify.lang.t('$vuetify.provision.cols.operation.title')"
                  @blur="$v.form.operation.$touch()"
                  @input="$v.form.operation.$touch()"
                  prepend-icon="mdi-panorama-fisheye"
                  autocomplete="off"
                  v-model="form.operation"
                ></v-select>
              </v-col>
              <v-col class="mb-0 py-0" cols="12" sm="12">
                <v-textarea
                  :label="$vuetify.lang.t('$vuetify.provision.cols.comment.title')"
                  auto-grow
                  prepend-icon="mdi-note-text"
                  autocomplete="off"
                  rows="2"
                  v-model="form.comment"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialog.shows.showProvision = false" text>{{ $vuetify.lang.t('$vuetify.btn.close') }}</v-btn>
          <v-btn
            :loading="loadingBtn"
            color="secondary"
            text
            type="submit"
          >{{ $vuetify.lang.t(dialog.saveBtnTitle) }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
  import FormMixin from '../../mixins/Common/Forms';
  import {required, numeric} from "vuelidate/lib/validators";
  import URLPath from "../../helpers/URL";
  import {mapGetters} from "vuex";

  export default {
    mixins: [FormMixin],
    props: {
      dialog: {
        type: Object,
        default: function () {
          return {
            title: "$vuetify.provision.new.title",
            shows: {
              showProvision: false
            },
            saveBtnTitle: "$vuetify.btn.save",
            action: "create"
          };
        }
      },
      form: {
        type: Object,
        default: function () {
          return {
            amount: null,
            operation: null,
            comment: null
          };
        }
      }
    },
    created() {
      this.setItemOperations();
    },
    validations() {
      let validators = {
        form: {
          amount: {required, numeric},
          operation: {required}
        }
      };
      return validators;
    },
    data: () => ({
      itemsOperations: [],
      loadingBtn: false
    }),
    methods: {
      setItemOperations() {
        let self = this;
        this.operations.forEach(r => {
          self.itemsOperations.push({
            text: self.$vuetify.lang.t("$vuetify.operations." + r),
            value: r
          });
        });
      },
      sendForm() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          let self = this;
          this.loadingBtn = true;
          this.save(this.getFormParam())
            .then(() => {
              this.$emit("getItems");
              if (self.dialog.action === "create" && self.form["username"] === self.$auth.user().username)
                self.$auth.fetch();
              self.$store.dispatch("setNotification", {
                status: true,
                message: self.$vuetify.lang.t("$vuetify.success_form")
              });
              self.dialog.shows.showApp = false;
              if (this.dialog.action === "create") this.resetForm();
            }).catch(() => {
            this.$forceUpdate();
          }).finally(() => {
            self.loadingBtn = false;
          })
        }
      },
      getFormParam() {
        let params = {};
        params["url"] = URLPath.USER.PROVISION.URI.replace(
          "{USER_ID}",
          this.form["user"]
        );
        params["data"] = this._.omit(this.form, ["user", "username", "oldAmount", "newAmount", "type", "reference", "createdAt"]);
        params["method"] = URLPath.USER.PROVISION.METHOD;
        params["data"]["amount"] = parseInt(params["data"]["amount"]);
        return params;
      },
      setForm(item) {
        this.form["user"] = item.id;
        this.form["username"] = this._.has(item, "user") ? item.user.username : item.username;
        this.form["oldAmount"] = item.oldAmount;
        this.form["newAmount"] = item.newAmount;
        this.form["type"] = item.type;
        this.form["operation"] = item.operation;
        this.form["amount"] = item.amount;
        this.form["reference"] = item.reference;
        this.form["createdAt"] = this.$moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss');
      },
      resetForm() {
        this.form.amount = null;
        this.form.operation = null;
        this.form.comment = null;
        this.$v.$reset();
      }
    },
    computed: {
      ...mapGetters({operations: "user/operations"}),
      errorsAmount() {
        let errors = [];
        if (!this.$v.form.amount.$dirty) return errors;

        !this.$v.form.amount.required &&
        errors.push(
          this.$vuetify.lang.t("$vuetify.provision.cols.amount.required")
        );

        !this.$v.form.amount.numeric &&
        errors.push(
          this.$vuetify.lang.t("$vuetify.provision.cols.amount.numeric")
        );

        return errors;
      },
      errorsOperation() {
        let errors = [];
        if (!this.$v.form.operation.$dirty) return errors;

        !this.$v.form.operation.required &&
        errors.push(
          this.$vuetify.lang.t("$vuetify.provision.cols.operation.required")
        );

        return errors;
      }
    }
  };
</script>
